module.exports = __webpack_public_path__ + "static/media/about-min.ca31e995.png";